<template>
  <div>
    <v-card flat class="pa-3 mt-2">
      <v-card-text>
        <v-form ref="form" class="multi-col-validation mt-6">
          <v-row>
            <v-toolbar dense dark color="primary">
              <v-toolbar-title><h4 class="font-weight-light">NEW SERVICES</h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-col md="4" cols="12"></v-col>
              <v-row>
                <v-col md="4" cols="12" v-if="id===0">
                  <v-select
                    v-model="type_of_service"
                    :items="['Cleaning','Repairs','Installation','Maintenance','Recharging Freon','Dismantling','Relocation','Sales','Other Services']"
                    label="Type of Service"
                    dense
                    outlined
                    :rules="rules.combobox_rule"
                  ></v-select>
                </v-col>
                <v-col md="12" cols="12">
                  <v-text-field
                    v-model="menu_title"
                    label="Service Title"
                    dense
                    outlined
                    :rules="rules.default_max_255_character_and_no_empty_rule"
                  ></v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field
                    v-model="amount"
                    label="Amount"
                    dense
                    outlined
                    :rules="rules.default_max_45_character_and_no_empty_rule"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-col>

                <v-col md="4" cols="12" v-if="id===0">
                  <v-select
                    v-model="branch_info"
                    :items="branch_items"
                    item-text="branch_code"
                    item-value="id"
                    label="Branch"
                    dense
                    outlined
                    :rules="rules.combobox_rule"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <!-- alert -->
            <v-col cols="12" v-show="alert">
              <v-alert color="warning" text class="mb-0">
                <div class="d-flex align-start">
                  <v-icon color="warning">
                    {{ icons.mdiAlertOutline }}
                  </v-icon>

                  <div class="ms-3">
                    <p class="text-base font-weight-medium mb-1">
                      {{ alert_message }}
                    </p>
                  </div>
                </div>
              </v-alert>
            </v-col>

            <v-col cols="12">
              <v-btn color="primary" class="me-3 mt-4" @click="save_caller" v-if="!saving"> Save
                changes
              </v-btn>
              <v-progress-circular :size="50" :width="5" color="primary" indeterminate
                                   v-else></v-progress-circular>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text class="mt-4">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-uppercase">Type of Service</th>
              <th class="text-uppercase">Service</th>
              <th class="text-center text-uppercase">Amount</th>
              <th class="text-center text-uppercase">Status</th>
              <th class="text-center text-uppercase">Edit</th>
              <th class="text-center text-uppercase">Deactivate</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in initialize_datas" :key="item.id">
              <td>
                {{ item.type_of_service }}
              </td>
              <td>
                {{ item.service_name }}
              </td>
              <td class="text-center">
                {{ formatPrice(item.amount) }}
              </td>
              <td class="text-center">
                <div v-if="item.is_active===1">
                  ACTIVE
                </div>
                <div v-if="item.is_active===0">
                  DEACTIVATED
                </div>
              </td>
              <td class="text-center">
                <v-icon
                  v-if="!is_updating"
                  class="mr-2"
                  color="success"
                  @click="update(item)"
                >
                  {{ icons.mdiPencilBoxOutline }}
                </v-icon>
                <v-progress-circular color="info" indeterminate
                                     v-else></v-progress-circular>
              </td>
              <td class="text-center">
                <div v-if="item.is_active===1">
                  <v-icon
                    v-if="!is_updating"
                    class="mr-2"
                    color="error"
                    @click="update_status(item,0)"
                  >
                    {{ icons.mdiToggleSwitchOff }}
                  </v-icon>
                  <v-progress-circular color="info" indeterminate
                                       v-else></v-progress-circular>
                </div>
                <div v-if="item.is_active===0">
                  <v-icon
                    v-if="!is_updating"
                    class="mr-2"
                    color="success"
                    @click="update_status(item,1)"
                  >
                    {{ icons.mdiToggleSwitch }}
                  </v-icon>
                  <v-progress-circular color="info" indeterminate
                                       v-else></v-progress-circular>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="is_edit_amount">
      <v-card>
        <v-form ref="form2" class="multi-col-validation mt-6">
          <v-card-text>
            <v-row>
              <v-col md="12" cols="12">
                <v-text-field
                  v-model="menu_title"
                  label="Service Title"
                  dense
                  outlined
                  :rules="rules.default_max_255_character_and_no_empty_rule"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  v-model="amount"
                  label="Amount"
                  dense
                  outlined
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                  type="number"
                  min="0"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-alert color="warning" text class="mb-0" v-show="alert">
            <div class="d-flex align-start">
              <v-icon color="warning">
                {{ icons.mdiAlertOutline }}
              </v-icon>

              <div class="ms-3">
                <p class="text-base font-weight-medium mb-1">
                  {{ alert_message }}
                </p>
              </div>
            </div>
          </v-alert>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!saving"
            color="primary"
            @click="update_info"
          >
            Update Changes
          </v-btn>
          <v-progress-circular
            :size=50
            :width="5"
            color="primary"
            indeterminate
            v-else
          ></v-progress-circular>
          <!-- alert -->

        </v-card-actions>
      </v-card>
    </v-dialog>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {
  mdiAlertOutline,
  mdiCloudUploadOutline,
  mdiAccountSearchOutline,
  mdiToggleSwitch,
  mdiToggleSwitchOff,
  mdiPencilBoxOutline
} from '@mdi/js'
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {

    branch_info: '',
    branch_items: [],

    saving: false,
    alert: false,
    alert_message: '',

    is_edit_amount: false,
    b_id: 0,
    id: 0,
    amount: '0',
    email: '',
    type_of_service: '',
    menu_title: '',
    position: '',

    initialize_datas: [],
    selected_to_edit: {},
    is_updating: false,
    is_cooked: false,
  }
}

export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      show: false,
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
        mdiAccountSearchOutline,
        mdiPencilBoxOutline,
        mdiToggleSwitch,
        mdiToggleSwitchOff,
      },
    }
  },
  mounted() {
    this.initialize_data()
  },
  data() {
    return initialState()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
    ...mapGetters('authentication', ['branch', 'branch_id_selected', 'year', 'month_start', 'month_end', 'month_of', 'user_id']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('branch_information', ['get_branches_active']),
    ...mapActions('menu_order', ['register_new_service', 'get_all_service', 'update_new_service', 'update_status_new_service']),
    croppie(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var reader = new FileReader();
      reader.onload = e => {
        this.cropped = this.croppieImage_mem_1 = e.target.result
      };
      reader.readAsDataURL(files[0]);
    },

    resett() {
      this.$refs.refInputEl.value = ''
      this.cropped = this.avatarImg
    },
    initialize_data() {
      this.get_all_service({
        branch_id: this.branch_id_selected
      })
        .then(response => {
          this.initialize_datas = response.data
        })
        .catch(error => {
          console.log(error)
        })
      this.get_branches_active()
        .then(response => {
          this.branch_items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    reset() {
      Object.assign(this.$data, initialState())
      this.initialize_data()
    },
    save_caller() {
      this.saving = true
      this.alert = false
      if (this.$refs.form.validate()) {
        const data = new FormData()
        data.append('branch_id', this.branch_info)
        data.append('title', this.menu_title.toUpperCase(),)
        data.append('type_of_service', this.type_of_service,)
        data.append('amount', this.amount)
        this.register_new_service(data)
          .then(response => {
            var color = 'success'
            if (response.status === 201) {
              color = 'error'
            } else {
              this.reset()
            }
            this.change_snackbar({
              show: true,
              color: color,
              text: response.data,
            })
          })
          .catch(error => {
            console.log(error)
            this.alert = true
            this.alert_message = error.response.data.message
            this.saving = false
          })
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving = false
      }
    },
    update_status(item, status) {
      this.update_status_new_service({
        id: item.id,
        status: status,
      })
        .then(response => {
          var color = 'success'
          if (response.status === 201) {
            color = 'error'
          } else {
            this.reset()
          }
          this.change_snackbar({
            show: true,
            color: color,
            text: response.data,
          })
          this.initialize_data()
        })
        .catch(error => {
          console.log(error)
          this.alert = true
          this.alert_message = error.response.data.message
          this.saving = false
        })
    },
    update(item) {
      this.amount = item.amount
      this.menu_title = item.service_name
      this.selected_to_edit = item
      this.is_edit_amount = true
    },
    update_info() {
      if (this.$refs.form2.validate()) {
        this.update_new_service({
          id: this.selected_to_edit.id,
          title: this.menu_title.toUpperCase(),
          amount: this.amount,
        })
          .then(response => {
            var color = 'success'
            if (response.status === 201) {
              color = 'error'
            } else {
              this.reset()
            }
            this.change_snackbar({
              show: true,
              color: color,
              text: response.data,
            })
            this.initialize_data()
          })
          .catch(error => {
            console.log(error)
            this.alert = true
            this.alert_message = error.response.data.message
            this.saving = false
          })
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving = false
      }
    },
  },
}
</script>
